import { Link } from 'react-router-dom'
import { Button } from '@/components/common'
import { useSEO } from '@/hooks/useSEO'

export const NotFound = () => {
  useSEO({
    title: '404 - Page Not Found',
    description: 'The page you are looking for does not exist or has been moved.',
    url: 'https://bindertech.com/404',
    type: 'website',
  })
  return (
    <div className="flex min-h-screen items-center justify-center bg-background-light dark:bg-background-dark px-4">
      <div className="text-center">
        <h1 className="text-9xl font-black text-primary mb-4">404</h1>
        <h2 className="text-3xl font-bold text-text-main-light dark:text-text-main-dark mb-4">
          Page Not Found
        </h2>
        <p className="text-text-sub-light dark:text-text-sub-dark mb-8 max-w-md mx-auto">
          The page you're looking for doesn't exist or has been moved. Please check the URL or
          return to the homepage.
        </p>
        <div className="flex gap-4 justify-center">
          <Link to="/">
            <Button variant="primary">Go Home</Button>
          </Link>
          <Button variant="outline" onClick={() => window.history.back()}>
            Go Back
          </Button>
        </div>
      </div>
    </div>
  )
}

